import React from 'react';
import { SectionWrapper } from '../PrivaceNotive/style';
export const TermsOfUse = () => {
  return (
    <SectionWrapper>
      <h1 className="title"> TERMOS DE USO DPO HUB</h1>
      <p>Bem-vindo ao DPO Hub!</p>
      <p>
        Na Daniel Advogados temos inovação e tecnologia em nosso DNA. Nós impulsionamos inovação e
        tecnologia nos nossos serviços jurídicos, garantindo maior segurança jurídica aos nossos
        clientes e fazemos isso de um jeito diferente. O DPOHub foi desenvolvido pela Daniel
        Advogados para oferecer aos clientes serviços jurídicos de forma mais ágil e interativa. Ao
        acessá-lo, você poderá controlar seu orçamento, visualizar suas demandas em tempo real,
        fazer autoavaliações (self-assessments) e solicitar novas consultas a qualquer tempo.
      </p>
      <p>
        Estes Termos de Uso regulam o acesso e a utilização ao DPO Hub de titularidade da{' '}
        <strong>Daniel Advogados</strong> (CNPJ 33.073.800/0001-91, Endereços: São Paulo - Rua
        Leopoldo Couto Magalhães Junior, 758, cj 52, 5º andar, Condomínio New Century – Itaim Bibi -
        CEP: 04542-000, Tel.: (55 11) 2103.9107, Fax: (55 11) 2103.9124 e Rio de Janeiro - Avenida
        República do Chile, 330/ 21º andar - Torre Oeste – Centro - CEP: 20.031-170 Tel.: (55 21)
        2102.4212, Fax: (55 21) 2524.3344)). A utilização do DPO Hub é condicionada à aceitação
        destas regras.
      </p>
      <h2 className="subTitle">
        <span className="ml-none">1.</span> PRINCIPAIS CONCEITOS
      </h2>
      <p>
        Antes de adentrarmos aos temas destes Termos, gostaríamos de esclarecer a você alguns
        conceitos importantes para a boa leitura deste material.
      </p>
      <ul>
        <li>
          <strong>Cliente:</strong> pessoas jurídicas ou físicas que contratam os Serviços da Daniel
          Advogados e do DPO Hub.
        </li>
        <li>
          <strong> Documentos:</strong> todas as avaliações, relatórios e outros documentos que o
          Usuário possa gerar ou ter acesso por meio do DPO Hub.
        </li>
        <li>
          <strong>Plataforma:</strong> plataforma DPO Hub acessível pelo site{' '}
          <a href="https://dpo-hub.daniel-ip.com/home" target="_blank" rel="noopener noreferrer">
            https://dpo-hub.daniel-ip.com/home
          </a>
          .
        </li>
        <li>
          <strong> Serviços:</strong> todos os recursos e serviços prestados pela Daniel por meio da
          Plataforma DPO Hub.
        </li>
        <li>
          <strong> Usuários:</strong> pessoa física cadastrada na Plataforma, que possua ou não
          vínculo empregatício com o Cliente. Esta definição abrange o Usuário Administrador.
        </li>
        <li>
          <strong> Usuário Externo:</strong> pessoa física, que possua ou não vínculo empregatício
          com o Cliente, autorizada pelos Usuários a acessar a Plataforma, sem a necessidade de
          cadastro.
        </li>
        <li>
          <strong> Usuário Administrador:</strong> usuário indicado pelo Cliente para criar e
          gerenciar outros Usuários.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">2.</span> SERVIÇOS
      </h2>
      <ul className="listStyle-visible">
        <li className="listStyle-none">
          2.1. A Daniel disponibiliza aos Usuários uma Plataforma que viabiliza que o Cliente
          realize auto- avaliações (self-assessments) automatizadas sobre sua organização, submeta
          esses documentos e gere relatórios para sua própria avaliação ou da Daniel (“Serviços”). A
          Plataforma DPO Hub é contratada por Clientes, que indicam um Usuário Administrador para
          utilizá-la em seu nome.
        </li>
        <li>
          2.2. O Usuário Administrador, por sua vez, pode criar outros Usuários e gerenciar seus
          acessos à Plataforma.
        </li>
        <li>
          2.3. Usuários podem indicar Usuários Externos, ou seja, pessoas físicas sem cadastro na
          Plataforma, para acessar recursos ou Documentos específicos dentro da Plataforma, por um
          período determinado no momento do cadastro do Usuário Externo.
        </li>
        <li>
          2.4. Os Serviços são prestados por meio da Plataforma, que funciona em modalidade de
          Software as a Service (SaaS) e é hospedado nos servidores da Amazon Web Services (AWS),
          cujos termos de uso estão disponíveis em:{' '}
          <a
            href="https://aws.amazon.com/pt/service-terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://aws.amazon.com/pt/service-terms/
          </a>
          .
        </li>
        <li>
          2.5. Para a prestação dos Serviços, a Daniel poderá contratar terceiros para executar
          partes de sua operação, como na hospedagem em nuvem dos seus servidores.
        </li>
        <li>
          {' '}
          2.6. Caso o Cliente tenha contratado os Serviços da Daniel mediante um Contrato específico
          e assinado (“Contrato”), em caso de eventuais conflitos entre o Contrato e este
          Instrumento, prevalecerá o disposto no Contrato.
        </li>
        <li>
          2.7. A extensão dos Serviços prestados dependerá dos perfis de Usuários e Usuários
          Externos, do plano de Serviços contratado pelo Cliente e da parametrização dos serviços
          disponibilizados na Plataforma. As instruções para utilização de cada um dos Serviços
          encontram-se no ambiente da Plataforma.
        </li>
        <li>
          2.8. Dentre os Serviços prestados está o Simulador de Multas, que permite a simulação do
          valor de eventual multa decorrente de infração à LGPD, calculada com base nos critérios e
          diretrizes definidos pela Autoridade Nacional de Proteção de Dados (ANPD) e nas
          informações fornecidas pelos Usuários.{' '}
        </li>
        <li>
          2.9. Sendo aceitos os termos deste Instrumento, a Daniel concede aos Usuários uma
          autorização de uso, podendo revogar essa licença conforme condições contratuais.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 3. ACESSO E CADASTRO DE USUÁRIOS
      </h2>
      <ul className="listStyle-visible">
        <li>
          3.1. O Cliente é responsável por cadastrar seus Usuários e Usuários Externos sendo de sua
          integral responsabilidade a exatidão e autenticidade dos dados inseridos para cadastro.
        </li>
        <li>
          3.2. A Plataforma não poderá ser responsabilizada por Usuários ou Usuários Externos
          cadastrados por engano, ou, má-fé por outros Usuários ou terceiros.
        </li>
        <li>
          3.3. A Plataforma também não poderá ser responsabilizada em caso de cadastros não
          realizados em razão de erros nas informações prestadas pelo Cliente, seus colaboradores,
          representantes, Usuários ou Usuários Externos.
        </li>
        <li>
          3.4. Duas ou mais pessoas físicas não podem usar os Serviços com um único cadastro de
          Usuário, ou Usuário Externo.
        </li>
        <li>
          3.5. O Cliente poderá designar e expressamente autorizar um (ou mais) Usuário(s)
          Administrador(es) como seu agente para gerenciar sua conta com a Daniel e com a
          Plataforma, o que inclui, por exemplo, ajuste das configurações de administração,
          concessão de acesso e autorização de uso, solicitação de serviços diversos ou adicionais,
          fornecimento de registro de utilização e desempenho, aceitação de notificações,
          divulgações e termos e condições.
        </li>
        <li>
          3.6. Para utilizar a Plataforma, os Usuários ou Usuários Externos devem ser maiores de 18
          (dezoito) anos e possuírem plena capacidade legal para tanto; ou estarem devidamente
          representados para assumir as responsabilidades aqui estabelecidas.
        </li>
        <li>
          3.7. O Usuário ou Usuário Externo declara que detém todas as autorizações legais
          necessárias para fazer o cadastro, aceitar estes Termos de Uso e realizar qualquer
          operação em nome do Cliente. A Plataforma não será responsável pela falsidade desta
          declaração, cabendo ao Usuário ou Usuário Externo e ao Cliente o dever de indenizar a
          Plataforma e terceiros por todos os danos e prejuízos causados.
        </li>
        <li>
          3.8. A partir do cadastro pelo Cliente, o Usuário será notificado por e-mail e, após a
          confirmação de identidade, será direcionado para editar seu perfil na Plataforma e poderá
          utilizá-la após aceitar os Termos de Uso e ter ciência sobre o Aviso de Privacidade.
        </li>
        <li>
          3.9. O Usuário concorda que é responsável pela segurança e sigilo de seu login e senha,
          responsabilizando-se por todas as ações realizadas em sua conta.
        </li>
        <li>
          3.10. O Usuário se compromete a, em caso de perda, extravio ou suspeita de utilização
          indevida de sua conta, login ou senha, comunicar imediatamente o Cliente e a Plataforma
          (no endereço de e-mail <a href="mailto:dpo@daniel-ip.com">dpo@daniel-ip.com</a> ) para que
          sejam tomadas as medidas cabíveis.
        </li>
        <li>
          3.11. O Cliente é responsável pelas permissões de Usuários designadas por seus
          representantes e colaboradores, devendo estas serem definidas internamente em linha com
          seu organograma e organização corporativa.
        </li>
        <li>
          3.12. A Plataforma não se responsabiliza por danos advindos de permissões de Usuário ou
          Usuário Externo atribuídas por erro ou, má-fé por outros Usuários, terceiros,
          representantes ou colaboradores do Cliente.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 4. DISPONIBILIDADE DA PLATAFORMA E SUPORTE
      </h2>
      <ul className="listStyle-visible">
        <li>
          4.1. A Daniel busca disponibilizar a Plataforma em sua melhor versão possível, atualizando
          seu sistema constantemente e aplicando as melhores e mais eficientes práticas de mercado.
          Mesmo diante desses esforços, a experiência do Usuário na Plataforma depende do desempenho
          e compatibilidade de produtos e serviços prestados por terceiros, tais como smartphones,
          tablets e computadores, e de provedores de serviços de internet. A Daniel não se
          responsabiliza por falhas nos produtos ou serviços de terceiros que inviabilizem ou
          impactem a experiência de uso de sua Plataforma.{' '}
        </li>
        <li>
          4.2. Caso o Usuário tenha qualquer problema com o funcionamento regular da Plataforma,
          poderá contar com a Equipe de Tecnologia, Privacidade e Proteção de Dados da Daniel no
          endereço de e-mail{' '}
          <a href="mailto:equipe.tecnologia@danielip.com">equipe.tecnologia@danielip.com</a> .
        </li>
        <li>
          4.3. A Daniel não está obrigada a garantir que a Plataforma atenda às necessidades
          específicas do Cliente e de seus Usuários ou Usuários Externos, uma vez que a Plataforma
          não foi desenvolvida sob medida e não é customizável.
        </li>

        <li>
          4.4. A Daniel não se responsabiliza por violações dos dados armazenados em seu servidor
          que sejam resultantes de atos de Usuários ou Usuários Externos, colaboradores e
          representantes do Cliente, e nem daquelas resultantes de ação criminosa ou irregular de
          terceiros fora dos limites da previsibilidade técnica do momento em que estas vierem a
          ocorrerem.
        </li>
        <li>
          4.5. A Daniel poderá, a seu exclusivo critério, desenvolver novas funcionalidades para a
          Plataforma, podendo, inclusive, cobrar ou não valor adicional por cada nova
          funcionalidade. Na hipótese de funcionalidades que necessitem de cobrança adicional,
          somente serão disponibilizadas para o Cliente e seus Usuários ou Usuários Externos se
          contratadas mediante assinatura de aditivo ao contrato firmado com a Daniel.{' '}
        </li>
        <li>
          4.6. A Daniel poderá, também, descontinuar qualquer das funcionalidades que atualmente
          disponibiliza na Plataforma a seu exclusivo critério. Nessa hipótese, caso a
          funcionalidade descontinuada faça parte do pacote contratado pelo Cliente, o valor pago
          por ele será ajustado proporcionalmente a essa alteração.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 5. PROPRIEDADE INTELECTUAL
      </h2>
      <ul className="listStyle-visible">
        <li>
          5.1. A Plataforma e seus componentes funcionais e visuais são de titularidade e
          propriedade exclusiva da Daniel, de forma que os seus direitos autorais e outros direitos
          de propriedade intelectual são iguais aos conferidos às obras literárias nos moldes da
          legislação de direitos autorais vigentes no país, conforme expressa determinação da Lei
          9.609/98.
        </li>
        <li>
          5.2. Inclui-se como propriedade exclusiva da Daniel quaisquer aprimoramentos, correções,
          traduções, alterações, novas versões ou obras derivadas, realizadas pela Daniel,
          isoladamente ou em conjunto com terceiros.{' '}
        </li>
        <li>
          5.3. Na hipótese de a Daniel desenvolver e/ou implementar eventual sugestão do Cliente,
          Usuários ou Usuários Externos para modificação da Plataforma, os direitos autorais e
          industriais serão sempre da Daniel.{' '}
        </li>
        <li>
          5.4. Em hipótese alguma o Cliente e seus Usuários ou Usuários Externos terão acesso ao
          código-fonte da Plataforma e respectivo banco de dados, que são de propriedade exclusiva
          da Daniel.
        </li>
        <li>
          5.5. A Daniel concede uma autorização ao Usuário ou Usuários Externos para uso limitado,
          não exclusivo, não comercial, pessoal e intransferível, para visualizar, imprimir,
          descarregar e armazenar os conteúdos contidos na Plataforma apenas pelo tempo de vigência
          acordado em Contrato. A Daniel poderá tomar todas as medidas extrajudiciais e judiciais
          necessárias caso verifique o uso da Plataforma fora desta autorização.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 6. PRAZO E RESCISÃO
      </h2>
      <ul className="listStyle-visible">
        <li> 6.1. O prazo de vigência dos Serviços será aquele descrito no Contrato.</li>
        <li>
          6.2. Independentemente da forma de rescisão do presente Instrumento e do Contrato, a
          Daniel oferecerá um prazo de 5 (cinco) dias úteis para que o Cliente faça download dos
          Documentos e informações contidos na Plataforma. Após esse prazo, tais Documentos e
          informações serão excluídos.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span>7. LIMITAÇÃO DE RESPONSABILIDADE
      </h2>
      <ul className="listStyle-visible">
        <li>
          7.1. O Cliente é responsável pela veracidade, legitimidade e qualidade dos dados e
          Documentos inseridos pelos Usuários ou Usuários Externos na Plataforma e em suas diversas
          ferramentas. A Daniel está isenta de qualquer responsabilidade quanto aos dados gerados
          por terceiros a partir das informações inseridas na Plataforma.{' '}
        </li>
        <li>
          7.2. O valor obtido por meio do “Simulador de Multas” é estimado. A Daniel não se
          compromete com que o valor estimado da multa seja o mesmo aplicado no caso concreto, vez
          que o resultado depende, dentre outros fatores, das informações fornecidas pelo Usuário ao
          questionário, e que a ANPD poderá, a seu critério, adotar outra interpretação sobre o
          caso.
        </li>
        <li>
          7.3. O Usuário ou Usuários Externos não deverão usar, carregar, transmitir ou enviar de ou
          para a Plataforma qualquer conteúdo que possa violar a boa-fé, a legislação, ou que possa
          causar danos a Daniel ou a terceiros. Apesar de não ter obrigação legal de monitoramento,
          a Daniel, quando ciente do referido conteúdo, poderá excluí-lo a qualquer tempo.{' '}
        </li>
        <li>
          7.4. A Daniel não tem a obrigação de monitorar o acesso ou uso da Plataforma pelos
          Usuários ou Usuários Externos para verificar violações a este Instrumento, nem de revisar
          ou editar qualquer conteúdo. No entanto, a Daniel tem direito de fazê-lo para prestar
          suporte aos Usuários quando solicitado, averiguar seu cumprimento com estes Termos e para
          cumprir a lei aplicável ou, ordem ou exigência judicial, administrativa ou governamental.
        </li>
        <li>
          7.5. Este Instrumento não estabelece qualquer relação de mandato, sociedade e/ou
          associação, vínculo empregatício, agenciamento, representação, consórcio, joint venture ou
          responsabilidade solidária entre a Daniel, Cliente e Usuários ou Usuários Externos, que
          são pessoas independentes e autônomas para todos os fins de direito, tampouco confere
          poderes a uma das partes para a representação da outra em quaisquer negócios jurídicos. A
          relação aqui estipulada entre a Daniel e Usuários é válida exclusivamente para o objeto e
          efeitos deste Instrumento.{' '}
        </li>
        <ul>
          <li className="indent">
            7.5.1. Desse modo, a Daniel está isenta de responsabilidade perante a eventual
            existência de interpelação judicial ou administrativa cujos fatos fundamentem-se em
            conflitos entre o Cliente e seus colaboradores, representantes ou prepostos, Usuários ou
            Usuários Externos, e
          </li>
        </ul>

        <li>
          7.6. A Daniel não se responsabiliza por quaisquer danos sofridos, a despeito de seus
          esforços, em decorrência de ataques de vírus ou invasões sobre o equipamento do Usuário ou
          Usuário Externo em decorrência do acesso, utilização ou navegação por meio da Plataforma,
          ou como consequência da transferência de dados, arquivos, imagens ou textos.{' '}
        </li>
        <li>
          7.7. Ao aceitar os termos, os Usuários e ou Usuários Externos assumem obrigações,
          inclusive, mas não se limitando a:
        </li>
        <ul>
          <li className="indent">
            (i) manter o ambiente de seus computadores e demais dispositivos de acesso à Plataforma
            seguros, valendo-se de ferramentas específicas para tanto, tais como antivírus,
            firewall, entre outras, de modo a contribuir para a prevenção de riscos eletrônicos;
          </li>
          <li>
            (ii) utilizar sistemas operacionais e navegadores atualizados e eficientes para a plena
            utilização da Plataforma, de acordo com os requisitos da Plataforma; e
          </li>
          <li>
            (iii) equipar-se e responsabilizar-se pelos computadores, dispositivos móveis e
            dispositivos de hardware necessários para o acesso à Plataforma, bem como pelo acesso
            desses computadores e dispositivos à Internet.
          </li>
        </ul>

        <li>
          7.8. Qualquer violação às obrigações pelo Usuário ou Usuários Externos descritas neste
          Instrumento que possam representar uma possível falha na segurança do funcionamento da
          Plataforma e na prestação dos Serviços, ainda que potencial, poderá representar uma
          violação aos termos deste Instrumento, ensejando a suspensão dos Serviços até a
          normalização da Plataforma, ou mesmo a rescisão do presente Instrumento.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 8. CONFIDENCIALIDADE
      </h2>
      <ul className="listStyle-visible">
        <li>
          8.1. Todas as informações trocadas entre o Cliente, seus Usuários, a Daniel e Usuário
          Externo são consideradas Informações Confidenciais. O Cliente, seus Usuários, a Daniel e
          Usuários Externos cadastrados garantem que tratarão as informações com o sigilo e
          discrição necessários à prestação dos Serviços, responsabilizando-se por eventuais
          divulgações indevidas.
        </li>
        <li>
          8.2. Todas as informações relacionadas ao Contrato e eventual proposta comercial enviada à
          Empresa deverão ser entendidas como Informações Confidenciais.{' '}
        </li>
        <li>
          8.3. O conteúdo dos Documentos compartilhado por meio da Plataforma será também
          considerado confidencial, a não ser que disposto em contrário dentro dos seus próprios
          termos.
        </li>
        <li>
          8.4. Durante e após a vigência do Contrato, a parte que recebe as Informações
          Confidenciais deverá: (a) usar as Informações Confidenciais da outra parte apenas para os
          fins para que foram fornecidas; (b) não divulgar tais Informações Confidenciais a
          terceiros, exceto na medida do necessário (need-to-know basis) para seus advogados,
          auditores, consultores, e prestadores de serviços que estejam sob obrigações de
          confidencialidade que sejam, ao menos, tão restritivas quanto as disposições contidas no
          presente Instrumento; e (c) proteger tais Informações Confidenciais contra uso e
          divulgação não autorizados na mesma medida (mas usando nada menos do que um grau razoável
          de cuidado) em que protege suas próprias Informações Confidenciais de natureza similar.
        </li>
      </ul>
      <h2 className="subTitle">
        <span className="ml-none">●</span> 9. DISPOSIÇÕES FINAIS
      </h2>
      <ul className="listStyle-visible">
        <li>
          9.1. <strong>Sucessão</strong>. Este Instrumento vincula as partes e seus sucessores,
          sejam eles a qualquer título.
        </li>
        <li>
          9.2. <strong>Cessão</strong>. Os direitos concedidos de acordo com o presente Instrumento
          não podem ser transferidos ou cedidos pelo Cliente ou seus Usuários ou Usuários Externos,
          mas podem ser transferidos pela Daniel sem qualquer restrição ou notificação prévia,
          assumindo esse terceiro todas as obrigações constantes neste Instrumento.{' '}
        </li>
        <li>
          9.3. <strong>Novação</strong>. A tolerância da Daniel em exigir o estrito cumprimento das
          condições deste Instrumento, não constitui, em hipótese alguma, novação ou renúncia, nem
          impede que a Daniel exerça esses direitos a qualquer tempo.
        </li>
        <li>
          9.4. <strong>Subsistência</strong>. Todas as disposições deste Instrumento que prevejam a
          observância de obrigações ou responsabilidades após a rescisão ou extinção deste
          Instrumento e/ou dos Serviços, subsistirão à sua rescisão ou extinção e continuarão em
          pleno vigor e efeito, em especial no que tange à propriedade intelectual e
          confidencialidade.
        </li>
        <li>
          9.5. <strong>Cláusulas Independentes</strong>. Se alguma cláusula deste Instrumento for
          considerada ilegal, nula ou incapaz de ser cumprida por qualquer motivo, esta previsão
          será considerada uma cláusula independente da parte remanescente deste Instrumento e não
          afetará a validade ou a aplicabilidade do cumprimento dos termos do restante do presente.
        </li>
        <li>
          9.6. <strong>Lei aplicável e foro</strong>. Todos os itens deste Instrumento estão regidos
          pelas leis vigentes na República Federativa do Brasil. Para todos os assuntos referentes à
          sua interpretação e cumprimento, as partes se submeterão ao foro Central da Comarca de São
          Paulo, estado de São Paulo.
        </li>
        <li>
          9.7. <strong>Alterações</strong>. A Daniel reserva-se ao direito de alterar as condições
          deste Instrumento a qualquer momento, informando o Cliente e seus Usuários sobre tais
          mudanças posteriormente.
        </li>
      </ul>
      <p className="right">Última alteração: maio/2023</p>
    </SectionWrapper>
  );
};
